import {useNavigate} from 'react-router-dom';

import type {
  AvatarLabelProps,
  AvatarLayout,
} from '@/components/ui/avatar-label';
import {AvatarWithLabel} from '@/components/ui/avatar-label';
import {TooltipWrapper} from '@/components/ui/tooltip';
import {useAuthorize} from '@/hooks/useAuth';
import type {User} from '@/services/graphqlHooks';
import {cn} from '@/utils/ui';

export type UserAvatarProps = Pick<AvatarLabelProps, 'size' | 'className'> & {
  user: User;
  layout?: AvatarLayout;
  noName?: boolean;
};

const UserAvatar = ({
  user,
  size = 'default',
  layout = 'horizontal',
  noName,
  className,
}: UserAvatarProps) => {
  const navigate = useNavigate();
  const canViewUser = useAuthorize('VIEW_USER');

  const name = `${user.name.firstName} ${user.name.lastName}`;

  const handleClick = (evt: React.MouseEvent) => {
    if (!canViewUser) return;
    evt.stopPropagation();
    navigate(`/users/${user.userName}`);
  };

  return (
    <TooltipWrapper title={name}>
      <div
        className={cn({'cursor-pointer': canViewUser}, className)}
        onClick={handleClick}
      >
        <AvatarWithLabel
          src={user.avatar || undefined}
          fallback={`${user.name.firstName[0]}${user.name.lastName[0]}`}
          label={noName ? undefined : name}
          color="secondary"
          size={size}
          layout={layout}
        />
      </div>
    </TooltipWrapper>
  );
};

export default UserAvatar;
